module.exports = __webpack_public_path__ + "img/banner.ddf00b0e.jpg";